// the components the layout renders itself, which is why they cannot auto-load:
// the head has already flushed stylesheet_pack_tag by the time they mount
import FeatureFlagAlert from './components/FeatureFlag/FeatureFlagAlert';
import Footer from './components/OC/footer';
import { ProvidedMegaNav as MegaNav } from './components/OC/meganav';
import RichText from './components/OC/oc-rich-text';
import Text from './components/OC/oc-text';
import SkipToContent from './components/SkipToContent';
import ProvidedCrossingLocale from './components/location/CrossingLocale';
import Switcher from './components/location/Switcher';

export default {
  'FeatureFlag::Featureflagalert': FeatureFlagAlert,
  'Location::Switcher': Switcher,
  'Location::Crossinglocale': ProvidedCrossingLocale,
  'OC::Footer': Footer,
  'OC::Richtext': RichText,
  'OC::Text': Text,
  MegaNav,
  SkipToContent,
};
